var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 9.33326H9.80672L9.62005 9.15326C10.4201 8.21993 10.8334 6.9466 10.6067 5.59326C10.2934 3.73993 8.74672 2.25993 6.88005 2.03326C4.06005 1.6866 1.68672 4.05993 2.03338 6.87993C2.26005 8.7466 3.74005 10.2933 5.59338 10.6066C6.94672 10.8333 8.22005 10.4199 9.15338 9.61993L9.33338 9.8066V10.3333L12.1734 13.1666C12.4467 13.4399 12.8867 13.4399 13.1601 13.1666L13.1667 13.1599C13.4401 12.8866 13.4401 12.4466 13.1667 12.1733L10.3334 9.33326ZM6.33338 9.33326C4.67338 9.33326 3.33338 7.99326 3.33338 6.33326C3.33338 4.67326 4.67338 3.33326 6.33338 3.33326C7.99338 3.33326 9.33338 4.67326 9.33338 6.33326C9.33338 7.99326 7.99338 9.33326 6.33338 9.33326Z",
    fill: "url(#paint0_linear_434_14312)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_434_14312",
    x1: 7.68568,
    y1: 1.99951,
    x2: 7.68568,
    y2: 13.3716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4BB93"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.075444134c7019c5373c0a42fd8e124c.svg";
export { ForwardRef as ReactComponent };